/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InverterIGBTData } from './InverterIGBTData';
import type { InverterMOSFETData } from './InverterMOSFETData';
import type { InverterSimpleData } from './InverterSimpleData';
/**
 * Analytical inverter input.
 */
export type InverterAnalytical = {
    item_type?: InverterAnalytical.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: InverterAnalytical.component_type;
    inverter_data: (InverterSimpleData | InverterIGBTData | InverterMOSFETData);
    current_limit_rms?: (number | null);
};
export namespace InverterAnalytical {
    export enum item_type {
        COMPONENT = 'component',
    }
    export enum component_type {
        INVERTER_ANALYTICAL = 'InverterAnalytical',
    }
}

